export default __webpack_public_path__ + "static/media/montekristo.04c37e01.jpg";